import { ChevronDown } from "lucide-react";

interface FilterButtonProps {
  label: React.ReactNode;
  active?: boolean;
  dropdown?: boolean;
  href?: string | null;
}

export default function FilterButton({
  label,
  active = false,
  dropdown = true,
  href = null,
}: FilterButtonProps) {
  const className = `text-sm/6 px-3 py-1.5 border rounded-lg border-slate-200 flex items-center gap-2 ${
    active
      ? "bg-default-50 text-default-800 border-default-300"
      : "bg-white text-slate-600 hover:text-default-800 hover:border-default-300"
  }`;

  const content = (
    <>
      {dropdown && <ChevronDown className="w-4 h-4" />}
      <span>{label}</span>
    </>
  );

  return href ? (
    <a href={href} className={className}>
      {content}
    </a>
  ) : (
    <button className={className}>{content}</button>
  );
}
